import * as yup from "yup";
import { FORM_CONSTANTS } from "../constants/formConstants";

export const stepSchemas = {
  step1: yup.object().shape({
    agent: yup.mixed().required("Agente é obrigatório"),
    agent_name: yup
      .string()
      .min(3, "Nome deve ter pelo menos 3 caracteres")
      .max(100, "Nome deve ter no máximo 100 caracteres")
      .required("Nome do agente é obrigatório"),
    agent_job: yup
      .string()
      .min(3, "Função deve ter pelo menos 3 caracteres")
      .max(50, "Função deve ter no máximo 50 caracteres")
      .required("Função do agente é obrigatória"),
    price: yup
      .number()
      .typeError("Preço deve ser um número")
      .min(250, "Preço mínimo é R$ 250,00")
      .required("Preço é obrigatório"),
    // Campos opcionais (não obrigatórios para navegação)
    agent_id: yup.number().optional(),
    name: yup.string().max(255, "Nome muito longo").optional(),
    job: yup.string().max(255, "Função muito longa").optional(),
    seller_name: yup.string().max(255, "Nome do vendedor muito longo").optional(),
    auto_publish: yup.boolean().optional(),
    demo_url: yup.string().url("URL de demonstração deve ser válida").optional(),
    // Pricing info fields
    "pricing_info.discount_percentage": yup.number().optional(),
    "pricing_info.trial_period_days": yup.number().optional(),
  }),
  
  step2: yup.object().shape({
    categories: yup
      .array()
      .min(1, "Selecione pelo menos uma categoria")
      .required("Categorias são obrigatórias"),
    // Novos campos da API v1
    category_ids: yup.array().of(yup.number()).min(1, "Selecione pelo menos uma categoria"),
    features: yup.array().of(yup.string()),
    capabilities: yup.array().of(yup.string()),
    tags: yup.array().of(yup.string()),
    platform: yup.array().of(yup.string()),
  }),
  
  step3: yup.object().shape({
    description: yup.string().required("Descrição completa é obrigatória"),
  }),
  
  step4: yup.object().shape({}), // Media is optional
  
  step5: yup.object().shape({
    platform_name: yup
      .string()
      .required("Nome da plataforma é obrigatório"),
    platform_url: yup
      .string()
      .url("URL deve ser válida")
      .matches(/^https:\/\//, "URL deve começar com https://")
      .required("URL da plataforma é obrigatória"),
    platform_description: yup
      .string()
      .required("Descrição da plataforma é obrigatória"),
    credential_type: yup
      .string()
      .required("Tipo de credencial é obrigatório"),
    access_instructions: yup
      .string()
      .required("Instruções de acesso são obrigatórias"),
    configuration_steps: yup
      .string()
      .required("Passos de configuração são obrigatórios"),
    customization_options: yup
      .string()
      .required("Opções de personalização são obrigatórias"),
    setup_requirements: yup
      .string()
      .required("Requisitos de setup são obrigatórios"),
    contact_type: yup
      .string()
      .required("Tipo de contato é obrigatório"),
    contact_value: yup
      .string()
      .required("Contato é obrigatório"),
    contact_name: yup
      .string()
      .required("Nome do responsável é obrigatório"),
    support_hours: yup
      .string()
      .required("Horário de atendimento é obrigatório"),
  }),
  
  step6: yup.object().shape({
    playground_url: yup
      .string()
      .url("URL deve ser válida")
      .matches(/^https?:\/\//, "URL deve começar com http:// ou https://")
      .required("URL do playground é obrigatória"),
  }),
  
  step7: yup.object().shape({}), // Review step - no additional validation needed
};

export const getSchemaForStep = (step) => {
  return stepSchemas[`step${step}`] || yup.object();
};

// Schema para validação de publicação de agente
export const publishAgentSchema = yup.object().shape({
  agent_id: yup
    .number()
    .integer("ID do agente deve ser um número inteiro")
    .positive("ID do agente deve ser positivo")
    .required("ID do agente é obrigatório"),
  agent_data: yup.object().shape({
    name: yup.string().max(255, "Nome muito longo"),
    description: yup.string(),
    job: yup.string().max(255, "Função muito longa"),
    price: yup
      .number()
      .min(250, "Preço mínimo é R$ 250,00")
      .typeError("Preço deve ser um número"),
    category_ids: yup.array().of(yup.number().integer()),
    features: yup.array().of(yup.string()),
    capabilities: yup.array().of(yup.string()),
    tags: yup.array().of(yup.string()),
    platform: yup.array().of(yup.string()),
    demo_url: yup.string().url("URL de demonstração deve ser válida"),
    auto_publish: yup.boolean(),
    seller_name: yup.string().max(255, "Nome do vendedor muito longo"),
  })
});

// Schema para validação da atualização de status de leads
export const updateLeadStatusSchema = yup.object().shape({
  lead_id: yup
    .number()
    .integer("ID do lead deve ser um número inteiro")
    .positive("ID do lead deve ser positivo")
    .required("ID do lead é obrigatório"),
  status: yup
    .string()
    .oneOf(['new', 'contacted', 'qualified', 'converted', 'lost', 'invalid'], 
           "Status inválido")
    .required("Status é obrigatório"),
  notes: yup.string().max(1000, "Notas muito longas")
});